<template>
  <div class="signStatus" v-if="isShow">
    <img @click="toSign" :src="img" alt="" />
  </div>
</template>

<script>
import { Toast } from "vant";
import { queryseasonsignupbyseasonid } from "@/api/winterGame";
export default {
  name: "signStatus",
  props: {
    year: {
      // 哪个年分，2023 夏季赛
      type: Number,
      default: 2023,
    },
    season: {
      // 哪个赛季 spring 春季，summer 夏季  autumn  冬季 winter
      type: String,
      default: "summer",
    },
    isShow: {
      // 是否显示
      type: Boolean,
      default: false,
    },
    isSign: {
      // 是否报名了
      type: Boolean,
      default: false,
    },
    registrationStatus: {
      type: Number | String,
      default: ''
    },
    registrationStatusTips: {
      type: String,
      default: ''
    },
    currentSeasonId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      img: null,
      signObj: {
        cupHomeSignUpImg: '', // 松鼠杯首页报名入口图（已报名）
        cupHomeNoSignUpImg: '', // 松鼠杯首页报名入口图（未报名）
      },
      isDataLoaded: false // 标记接口数据是否已加载完成
    };
  },
  mounted() {
    // let imgName = "signIcon.png";
    // if (this.isSign) {
    //   imgName = "signSuccess.png";
    // }
    // this.img = require(`../../../assets/images/squirrelCup/2025/summer/${imgName}`);
    // 确保数据准备好后再查询
    if (this.currentSeasonId) {
      this.querySeasonSignUpBySeasonId();
    }
  },
  watch: {
    // 监听 currentSeasonId 的变化，当它从空变为有值时触发查询
    currentSeasonId: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          // 当 seasonId 变化时，重置数据加载状态
          this.isDataLoaded = false;
          this.querySeasonSignUpBySeasonId();
        }
      },
      immediate: false
    },
    // 监听 isSign 的变化，更新图片（仅当接口数据已加载完成后）
    isSign: {
      handler(newVal) {
        // 只有当接口数据已加载完成时才更新图片，避免接口未返回时更新失败
        if (this.isDataLoaded && this.signObj) {
          if (newVal && this.signObj.cupHomeSignUpImg) {
            this.img = this.signObj.cupHomeSignUpImg;
          } else if (!newVal && this.signObj.cupHomeNoSignUpImg) {
            this.img = this.signObj.cupHomeNoSignUpImg;
          }
        }
      },
      immediate: false
    }
  },
  methods: {
    // 查询报名配置
    querySeasonSignUpBySeasonId() {
      // 确保 currentSeasonId 存在才查询
      if (!this.currentSeasonId) {
        return;
      }
      queryseasonsignupbyseasonid({
        param: {
          seasonTagId: this.currentSeasonId
        }
      }).then(res => {
        if (res.code == 0) {
          const { cupHomeSignUpImg, cupHomeNoSignUpImg } = res.data;
          this.signObj = {
            cupHomeSignUpImg,
            cupHomeNoSignUpImg
          }
          // 标记数据已加载完成
          this.isDataLoaded = true;
          // 根据当前的 isSign 状态设置图片
          if (this.isSign) {
            this.img = this.signObj.cupHomeSignUpImg;
          } else {
            this.img = this.signObj.cupHomeNoSignUpImg;
          }
        } else {
          Toast(res.message);
        }
      })
    },
    toSign() {
      if (this.registrationStatus == 0 && !this.isSign) { // 产品配置下架了，直接弹出提示
        Toast(this.registrationStatusTips);
        return;
      }
      let url = `/subpackages/home/squirrelCup/signUp/index?year=${this.year}&season=${this.season}`;
      if (this.isSign) { // 报名成功，点击图片显示海报
        this.$emit('viewSignPoster');
      } else {
        wx.miniProgram.navigateTo({ url });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.signStatus {
  text-align: center;
  margin-bottom: 20px;
  img {
    width: 636px;
    height: 196px;
    position: relative;
    left:-10px;
  }
}
</style>
